export enum TagColor {
  PURPLE = "fioletowy",
  LIGHT_PURPLE = "liliowy",
  GREEN = "zielony",
  BLUE = "niebieski",
  ORANGE = "pomarańczowy",
  RED = "czerwony",
  GRAY = "szary",
}

export const getAvailableColorsForSelect = () => {
  return Object.values(TagColor).map((color) => ({
    label: color,
    value: color,
    color: color,
  }));
};

export const getColorForTag = (color?: string): string => {
  switch (color?.toLowerCase()) {
    case TagColor.PURPLE:
      return "primaryPurple700";
    case TagColor.LIGHT_PURPLE:
    case TagColor.GRAY:
      return "text500";
    case TagColor.GREEN:
      return "accentSuccess700";
    case TagColor.ORANGE:
      return "accentOrange700";
    case TagColor.BLUE:
      return "accentBlue700";
    case TagColor.RED:
      return "accentRed700";
    default:
      return color?.startsWith("#") ? adjustColor(color) : "text500"; // z backendu mogą przychodzić kolory w hexie
  }
};

export const getBackgroundColorForTag = (color?: string): string => {
  switch (color?.toLowerCase()) {
    case TagColor.PURPLE:
      return "primaryPurple100";
    case TagColor.LIGHT_PURPLE:
      return "translucentPurple";
    case TagColor.GREEN:
      return "accentSuccess100";
    case TagColor.ORANGE:
      return "accentOrange100";
    case TagColor.BLUE:
      return "accentBlue100";
    case TagColor.RED:
      return "accentRed100";
    case TagColor.GRAY:
      return "translucentPurple3";
    default:
      return color?.startsWith("#") ? color : "translucentPurple3";
  }
};

export const getColorForFullCalendar = (color?: string): string => {
  switch (color?.toLowerCase()) {
    case TagColor.PURPLE:
      return "primaryPurple200";
    case TagColor.LIGHT_PURPLE:
      return "primaryPurple100";
    case TagColor.GREEN:
      return "accentSuccess200";
    case TagColor.ORANGE:
      return "accentOrange200";
    case TagColor.BLUE:
      return "accentBlue200";
    case TagColor.RED:
      return "accentRed200";
    case TagColor.GRAY:
      return "text100";
    default:
      return "text100";
  }
};

export const adjustColor = (hex: string, amt = -80): string => {
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }

  let [r, g, b] = hex.match(/.{2}/g)!.map(c => parseInt(c, 16)); // convert hex to rgb

  r = Math.max(0, Math.min(255, r + amt));
  g = Math.max(0, Math.min(255, g + amt));
  b = Math.max(0, Math.min(255, b + amt));

  const rr = r.toString(16).padStart(2, '0');
  const gg = g.toString(16).padStart(2, '0');
  const bb = b.toString(16).padStart(2, '0');

  return `#${rr}${gg}${bb}`; // new hex
};
